var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-icons-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"page-icons-container__heading heading-m"},[_vm._v(" "+_vm._s(_vm.heading)+" ")])])]),_c('InfraPageIcons',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }